var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabricks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M27.9403 21.7714V17.5429L27.4627 17.2571L16 23.2571L5.13433 17.5429V15.0857L16 20.7429L28 14.5143V10.3429L27.5224 10.0571L16 16.1143L5.55224 10.6286L16 5.14286L24.4179 9.54286L25.0746 9.2V8.74286L16 4L4 10.2286V10.8571L16 17.1429L26.8657 11.4286V13.9429L16 19.6571L4.47761 13.6L4 13.8857V18.1143L16 24.3429L26.8657 18.6857V21.1429L16 26.8571L4.47761 20.8571L4 21.1429V21.7714L16 28L27.9403 21.7714Z",
    fill: "#FF3621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricks);
export default __webpack_public_path__ + "static/media/databricks.a24d3b741c9c06c3022c5142b1c5aa35.svg";
export { ForwardRef as ReactComponent };